export default "/images/vendor/flag-icons/flags/4x3/mq.svg?fe327ace5767815c40e373ea37ac9568";